// extracted by mini-css-extract-plugin
var _1 = "bpl__box__GeYPC";
var _2 = "bpl__box__m-background__ndLVk";
var _3 = "bpl__box__m-bordder-bottom__IBTtD";
var _4 = "bpl__box__m-border-top__oGoUo";
var _5 = "bpl__box__m-padding__mkBGv";
export { _1 as "box", _2 as "box__m-background", _3 as "box__m-bordder-bottom", _4 as "box__m-border-top", _5 as "box__m-padding" }
